<template>
<div id="deposit-01" class="container pr-5 pl-4 pt-5">
    <h3 class="font-weight-normal mb-4">เติมเงินง่ายๆ ทันใจ<br/>ใน 4 ขั้นตอน</h3>
        <div class="row mb-4">
            <div class="col number-bullet-width-flex">
                <div class="number-bullet rounded-circle d-flex align-items-center justify-content-center bg-primary-dimmed">
                    <p class="h5 font-weight-normal m-0 text-primary">1</p>
                </div>
            </div>
            <div class="col pl-0 d-flex align-items-center">
                <p class="font-weight-light m-0">ระบุจำนวนเงินที่ท่านต้องการเติมเข้าบัญชี</p>
            </div>
        </div>
        <div class="row mb-4">
            <div class="col number-bullet-width-flex">
                <div class="number-bullet rounded-circle d-flex align-items-center justify-content-center bg-primary-dimmed">
                    <p class="h5 font-weight-normal m-0 text-primary">2</p>
                </div>
            </div>
            <div class="col pl-0 d-flex align-items-center">
                <p class="font-weight-light m-0">ระบบจะคำนวณยอดเงินเพื่อให้ท่านโอนเงินเข้าบัญชี</p>
            </div>
        </div>
        <div class="row mb-4">
            <div class="col number-bullet-width-flex">
                <div class="number-bullet rounded-circle d-flex align-items-center justify-content-center bg-primary-dimmed">
                    <p class="h5 font-weight-normal m-0 text-primary">3</p>
                </div>
            </div>
            <div class="col pl-0 d-flex align-items-center">
                <p class="font-weight-light m-0">เมื่อท่านโอนเงินเข้าระบบแล้วให้กดยืนยันการโอนเงินและส่งสลิปยืนยันการโอนเงิน ระบบจะทำการตรวจสอบและอัพเดทยอดภายใน 30 นาที</p>
            </div>
        </div>
        <div class="row mb-5">
            <div class="col number-bullet-width-flex">
                <div class="number-bullet rounded-circle d-flex align-items-center justify-content-center bg-primary-dimmed">
                    <p class="h5 font-weight-normal m-0 text-primary">4</p>
                </div>
            </div>
            <div class="col pl-0 d-flex align-items-center">
                <p class="font-weight-light m-0">สามารถฝากเงินได้ตลอด 24 ชั่วโมง</p>
            </div>
        </div>
        <div class="stick-down-pusher"></div>
        <div class="stick-down p-4">
            <router-link class="btn btn-primary btn-lg btn-block" :to="{ name: 'deposit-02' }">เข้าใจและดำเนินการต่อ</router-link>
            <a class="btn btn-light btn-lg btn-block" :href="this.$util.url('member/home')">ย้อนกลับ</a>
        </div>
</div>
</template>

<script>
export default {
}
</script>

<style>
</style>
